export default {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.userId;
  },
  userType(state) {
    return state.type;
  },
};
